import { Instance } from 'mobx-state-tree';
import { DeleteCustomMappingsDtoModelBase } from './DeleteCustomMappingsDtoModel.base';

/* The TypeScript type of an instance of DeleteCustomMappingsDtoModel */
export interface DeleteCustomMappingsDtoModelType extends Instance<typeof DeleteCustomMappingsDtoModel.Type> {}

/* A graphql query fragment builders for DeleteCustomMappingsDtoModel */
export {
  selectFromDeleteCustomMappingsDto,
  deleteCustomMappingsDtoModelPrimitives,
  DeleteCustomMappingsDtoModelSelector,
} from './DeleteCustomMappingsDtoModel.base';

/**
 * DeleteCustomMappingsDtoModel
 */
export const DeleteCustomMappingsDtoModel = DeleteCustomMappingsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
